import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { timeConvert } from 'projects/selflearnv2-ui/src/app/helpers/functions';
import { toNumber } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { QuitPracticeDialogComponent } from '../quit-practice-dialog/quit-practice-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserFeedbackPopupComponent } from '../../shared/components/user-feedback-popup/user-feedback-popup.component';

@Component({
  selector: 'app-pyp-chapter-questions',
  templateUrl: './pyp-chapter-questions.component.html',
  styleUrls: ['./pyp-chapter-questions.component.css']
})
export class PypChapterQuestionsComponent implements OnInit {

  exerciseData:any;
  userInfo:any;
  userId:any;
  questionsData:any =[];
  currentQuestionData:any;
  currentQuestionNumber:any = 0;
  defaultQuestion: number = 0;
  disablePrev: boolean = true;
  disableNext: boolean = false;
  public flagData: any = {
    showCorrectChoice: false,
    isSolution: false,
    showSolutionBtn: false,
    isDisabled: false,
    isSelected: false,
    enableNextBtn: false,
    isPractice: true,
    isFeedback: false,
    isQuestionSubmit: false,
    isQuit: true,
    isQuestionSkipped: false,
    enableSkipBtn: false,
    localBookmarkFlag: false

  }
  public selectedData: any = {
    index: null,
    selectedQuestionData: null,
    selectedQuestionChoiceData: null,
    selectedOption: null,
    selectedOptionNumber: 0,
    reportErrorArray: []
  }
  public deviceWidth:any;
  public type: 'practice' | 'feedback' = 'practice';
  public topicAndSubTopic: any = null;
  public revCardNo: any = 0;
  public revCardData: any = {};
  public progresses: any = [];
  progIndex: number = -1;
  questionSubmitMessage: any;
  timeConvert = timeConvert
  // start of  Different question types
  matrixColumns: any = [
    ['P', 'Q', 'R', 'S'],
    ['A', 'B', 'C', 'D', 'E']
  ]
  matrixReponses: any = {};
  selectedAnswer: any = [];
  numPadDigits1To9: any = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
  selectedNPadBtnText = '';
  selectedMultiAnswer: any = {};
  // end of Different question types
  public initialLoading = true;
  attemptedQuestion:boolean = false;
  @ViewChild("questioncontainer") questioncontainer: ElementRef;
  currentTime: number = new Date().getTime();
  questionList:any = []
  timeSpent: number=0;
  interval:any;
  showGifIcon:any = true;
  isCurrentQuestionSubmitted:boolean = false;
  exerciseQuestionsData:any;
  scheduleid:any;
  ruleId:any;
  answeresQuestionData:any;
  targetExamId:any;
  pageNumber:any =1;
  nextApiCallPageNumber:any = 10;
  totalQuestionCount:any;
  constructor(public router: Router, public selfLearnService: SelfLearnService, public dialog: MatDialog,public spinner:NgxSpinnerService, private snackbar: MatSnackBar) { }

  ngOnInit(): void {
    //this.startTimer();
    this.targetExamId =Number(localStorage.getItem('pyqTargrtExamId'))
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userId = this.userInfo.userDto.userId;
        this.getPYQuestions();
        this.getPyQuestionsCount();   
  }
  startTimer() {
    this.interval = setInterval(() => {
      if(!this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted)
           this.timeSpent++;
    },1000)
  }
getPyQuestionsCount(){
  this.spinner.show();
  let payload:any ={
    "question_type": {
      "values": [
        "5f0aed9b-8b11-4653-93bc-65941bf3da3f",
        "ffc0b3e6-f1c4-45df-a302-918fda45e122",
        "ec2f3aec-e64c-11ec-8fea-0242ac120002",
        "6beee0f4-2862-49dc-b26a-4be23ee8b353",
        "20fbaaec-85fa-42be-8d10-7d442e982301"
      ],
      "is_not_enabled": false
    },
    "status": {
      "values": [
        "approved"
      ],
      "is_not_enabled": false
    },
    "previous_year": {
       "exam": this.targetExamId,
      "date": null
    },
    "exam_type": this.selfLearnService.getCmsExamID().toString(),
    "examType": {
      "values": [
        this.selfLearnService.getCmsExamID().toString()
      ]
    },
    "toc": {
      "subject_id": [
        this.selfLearnService.getSubjectId()
      ],
      "chapter_id": [
        this.selfLearnService.getChapterId()
      ],
      "grade": [
        this.selfLearnService.getGradeId()
      ]
    },
    "fetchall": true
  }
  this.selfLearnService.getPreviousYearQuestionsCountForChapter(payload).subscribe((res:any) => {
    this.totalQuestionCount = res.totalRecords;
    this.spinner.hide();
  })
}

  getPYQuestions(){
    this.spinner.show();
    let payload:any = {
      "pageNumber": this.pageNumber,
      "pageSize": 10,
      "question_type": {
        "values": [
          "5f0aed9b-8b11-4653-93bc-65941bf3da3f",
          "ffc0b3e6-f1c4-45df-a302-918fda45e122",
          "ec2f3aec-e64c-11ec-8fea-0242ac120002",
          "6beee0f4-2862-49dc-b26a-4be23ee8b353",
          "20fbaaec-85fa-42be-8d10-7d442e982301"

        ],
        "is_not_enabled": false
      },
      "status": {
        "values": [
          "approved"
        ],
        "is_not_enabled": false
      },
      "previous_year": {
        "exam":this.targetExamId,
        "date": null
      },
      "exam_type": this.selfLearnService.getCmsExamID().toString(),
      "examType": {
        "values": [
          this.selfLearnService.getCmsExamID().toString(),
        ]
      },
      "toc": {
        "subject_id": [
          Number(this.selfLearnService.getSubjectId())
        ],
        "chapter_id": [
          Number(this.selfLearnService.getChapterId())
        ],
        "grade": [
          Number(this.selfLearnService.getGradeId())
        ]
      },
      "fetchall": true
    }
this.selfLearnService.getPreviousYearQuestionsForChapter(payload).subscribe((res:any) =>{
      console.log(res);
      this.spinner.hide();
     if(res.data.length>0){
      res.data.map((que:any) => {
        this.questionsData.push(que)
      })
      if( localStorage.getItem('exerciseCurrentQuestion')){
        this.currentQuestionNumber = Number(localStorage.getItem('exerciseCurrentQuestion'));
        this.currentQuestionData  = this.questionsData[this.currentQuestionNumber];
        this.showSolution();
        localStorage.removeItem('exerciseCurrentQuestion')
      }else{
        this.currentQuestionData = this.questionsData[this.currentQuestionNumber];
      }

      this.getDefaultInfoForQuestions();
     }else{
      this.snackbar.open('No questions found', 'Close', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'end'
      })
      this.router.navigate(['selfLearn-V2/chapter']);
     }

     
})
  }


  quitPractice() {
    const config: MatDialogConfig = {
      // width: '620px',
      panelClass: ['qiut-practice-modal', 'mweb-stiky-bottom'],
      data: {
        topicName: this.selfLearnService.getTopicName(),
        type: "Quit Practice",
        isFromPyq: true
      } 
    };
    this.dialog.open(QuitPracticeDialogComponent, config);

  }
  radioChange(answer: any, selectedIndex:any) {
    this.currentQuestionData.questionInfo.questionResponse =  selectedIndex;
    this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse = selectedIndex;
    this.selectedData.selectedOption = answer;
    this.selectedData.selectedOptionNumber = selectedIndex
    this.flagData.isSelected = true;
    this.saveIndex(selectedIndex-1);
  }

  isIncorrect(qc:any, option: number): boolean {
    if(this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse == option){
      return option !== toNumber(this.currentQuestionData.question.correct_answer[0]);
    }else{
      return false;
    }
    
  }
  // padBtnClick(e: any, btnVal: any) {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   let newAns: any;
  //  //const  currentAns = this.selectedAnswer[0] || "";
  //   let  currentAns:any = this.selectedAnswer || "";
  //   if (btnVal == "clear") {
  //     if (currentAns.length > 1) {
  //       newAns = [currentAns.substring(0, currentAns.length - 1)];
  //     } else {
  //       newAns = [];
  //     }
  //     this.selectedNPadBtnText = "";
  //   } else {
  //     if (this.revCardData.questiontype == 'Integer') {
  //       if (/^[0-9]$/.test(btnVal)) {
  //         this.selectedNPadBtnText = btnVal;
  //         newAns = [btnVal];
  //       } else {
  //         this.selectedNPadBtnText = "";
  //         newAns = [];
  //       }
  //     }
  //     else if (btnVal == "-") {
  //       if (currentAns[0] != "-") {
  //         if (currentAns.length >= 20) {
  //           alert("Answer should have less than 20 characters");
  //         } else {
  //           this.selectedNPadBtnText = "-";
  //           if (currentAns[0] == ".") {
  //             newAns = [("-0" + currentAns)];
  //           } else {
  //             newAns = [("-" + currentAns)];
  //           }
  //         }
  //       } else {
  //         newAns = [(currentAns.substring(1))];
  //       }
  //     } else if (btnVal == ".") {
  //       if (currentAns.indexOf(".") < 0) {
  //         if (currentAns.length >= 20) {
  //           alert("Answer should be less than 20 characters");
  //         } else {
  //           this.selectedNPadBtnText = ".";
  //           if (currentAns == "-") {
  //             newAns = [("-0.")];
  //           } else {
  //             newAns = [(currentAns + ".")];
  //           }
  //         }
  //       }
  //     } else if (currentAns.length >= 20) {
  //       alert("Answer should be less than 20 characters");
  //     }
  //     else {
  //       let decPointPos = currentAns.indexOf("."), canAppend = true;
  //       if (decPointPos >= 0) {
  //         if (currentAns.length >= decPointPos + 5) {
  //           canAppend = false;
  //           alert("only 4 decimal places are allowed");
  //         }
  //       }
  //       if (canAppend) {
  //         this.selectedNPadBtnText = btnVal;
  //         newAns = [(currentAns + btnVal)];
  //       }
  //     }
  //   }
  //   this.selectedAnswer = newAns || this.selectedAnswer;
  // }
  saveIndex(i: any) {
    this.selectedData.index = i;
  }

  isCorrect(qc:any, option: number): boolean {
    return option === toNumber(this.questionsData[this.currentQuestionNumber].question.correct_answer[0]);
  }
  showSolution(): any {
    this.flagData.isSolution = true;
    this.getVideoSolution();
  }

  showSolutionMobile(): any {
    this.flagData.isSolution = !this.flagData.isSolution
  }
  nextQuestion(){
    this.selectedMultiAnswer={}
    this.selectedAnswer =[];
    this.selectedNPadBtnText ='';
    if(this.currentQuestionNumber >= this.questionsData?.length-1){
      //this.calculateTotalScore();
      if(this.questionsData.length != this.totalQuestionCount && this.nextApiCallPageNumber-1== this.currentQuestionNumber ){
        this.pageNumber++;
        this.nextApiCallPageNumber = this.nextApiCallPageNumber+10;
        this.getPYQuestions();
      }else{
        this.router.navigate(['selfLearn-V2/pyp-chapter-completion']);
      }
    
    }else{

      this.flagData.isSolution = false;
      this.currentQuestionData = this.questionsData[++this.currentQuestionNumber];
      console.log(toNumber(this.questionsData[this.currentQuestionNumber].question.correct_answer[0])) 

      this.updateCurrentQuestionTimer();
    }

    
  }
  submitSelectedQuestion(){
    if(this.questionsData[this.currentQuestionNumber].question_type=="multiple correct mcq"){
      let returnMC = false;
      let optionsChosen : any = []; 
     const keys = Object.keys(this.selectedMultiAnswer); 
    let correctArr = this.questionsData[this.currentQuestionNumber].question.correct_answer.toString();
    let correctCheck = false;
    for (let i = 0, l = keys.length; i < l; i++) {  
      if (this.selectedMultiAnswer[keys[i]] === true) {
        optionsChosen.push(keys[i]); 
        console.log(correctArr.includes(keys[i]));
          if(!correctArr.includes(Number(keys[i])) && !returnMC){
           correctCheck = true; 
         }
     }
    }  
    this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse = optionsChosen.toString();
     const  iscorrectanswer = (!correctCheck && (correctArr.length ==optionsChosen.length)) ? true : false;
     console.log('iscorrectanswer',iscorrectanswer);
     
    this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted = true;
    this.questionsData[this.currentQuestionNumber].questionInfo.questionStatus = "answered"
    this.questionsData[this.currentQuestionNumber].questionInfo.timeSpentOnQuestion = this.timeSpent;
    this.questionsData[this.currentQuestionNumber].questionInfo.isCorrect = iscorrectanswer
    this.questionsData[this.currentQuestionNumber].questionInfo.marks = iscorrectanswer ? 1 : 0
    this.questionsData[this.currentQuestionNumber].questionInfo.questionResponseTimeStamp = moment().unix().toString();
    this.saveQuestionResponse(this.questionsData[this.currentQuestionNumber].questionInfo);
  } else if(this.questionsData[this.currentQuestionNumber].question_type=="numerical value question" || this.questionsData[this.currentQuestionNumber].question_type=="integer type question"){
    this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted = true;
    this.questionsData[this.currentQuestionNumber].questionInfo.questionStatus = "answered"
    this.questionsData[this.currentQuestionNumber].questionInfo.timeSpentOnQuestion = this.timeSpent;
    this.questionsData[this.currentQuestionNumber].questionInfo.isCorrect = this.questionsData[this.currentQuestionNumber].question.correct_answer[0] == this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse.toString()
    this.questionsData[this.currentQuestionNumber].questionInfo.marks = this.questionsData[this.currentQuestionNumber].question.correct_answer[0] == this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse.toString() ? 1 : 0
    this.questionsData[this.currentQuestionNumber].questionInfo.questionResponseTimeStamp = moment().unix().toString();
    this.saveQuestionResponse(this.questionsData[this.currentQuestionNumber].questionInfo);
  }else {

  
    this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted = true;
    this.questionsData[this.currentQuestionNumber].questionInfo.questionStatus = "answered"
    this.questionsData[this.currentQuestionNumber].questionInfo.timeSpentOnQuestion = this.timeSpent;
    this.questionsData[this.currentQuestionNumber].questionInfo.isCorrect = this.isCorrect(12, Number(this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse))
    this.questionsData[this.currentQuestionNumber].questionInfo.marks = this.isCorrect(12, Number(this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse)) ? 1 : 0
    this.questionsData[this.currentQuestionNumber].questionInfo.questionResponseTimeStamp = moment().unix().toString();
    this.saveQuestionResponse(this.questionsData[this.currentQuestionNumber].questionInfo);

    // if(this.questionsData.length != this.totalQuestionCount && this.nextApiCallPageNumber-1== this.currentQuestionNumber){
    //   this.pageNumber++;
    //   this.nextApiCallPageNumber = this.nextApiCallPageNumber+10;
    //   this.getPYQuestions();
    // }
      
  }
  }
  skipQuestion(){
    this.selectedMultiAnswer={};
    this.selectedAnswer =[];
    this.selectedNPadBtnText ='';
    if(this.currentQuestionNumber >= this.questionsData?.length-1){
         
           if(this.questionsData.length != this.totalQuestionCount && this.nextApiCallPageNumber-1== this.currentQuestionNumber ){
            this.pageNumber++;
            this.nextApiCallPageNumber = this.nextApiCallPageNumber+10;
            this.getPYQuestions();
          }else{
            this.router.navigate(['selfLearn-V2/pyp-chapter-completion']);
          }
    }else{
      this.flagData.isSolution = false;
      this.questionsData[this.currentQuestionNumber].questionInfo.timeSpentOnQuestion = this.timeSpent;
      this.currentQuestionData = this.questionsData[++this.currentQuestionNumber];
      if(this.questionsData.length != this.totalQuestionCount && this.nextApiCallPageNumber-1== this.currentQuestionNumber){
        this.pageNumber++;
        this.nextApiCallPageNumber = this.nextApiCallPageNumber+10;
        this.getPYQuestions();
      }
      this.updateCurrentQuestionTimer();
    }
  }
  previousQuestion(){
    this.flagData.isSolution = false;
    this.questionsData[this.currentQuestionNumber].questionInfo.timeSpentOnQuestion = this.timeSpent;
    this.currentQuestionData = this.questionsData[--this.currentQuestionNumber]; 
    this.updateCurrentQuestionTimer();
  }
  isDoneBtnDisabled(){
    return false;
  }
  saveQuestionResponse(questionInfo:any){
   let finalPayLoad:any = {
    "chapterId": this.selfLearnService.getChapterId(),
    "chapterName":this.selfLearnService.getChapterName(),
    "currentPage": this.pageNumber,
    "examId": this.selfLearnService.getCmsExamID(),
    "gradeId": this.selfLearnService.getGradeId(),
    "pageSize": 10,
    "questionsDetails": [
        {
            "difficultyLevel": "moderate",
            "isAttempted": questionInfo.isSubmitted,
            "isBookmarked": questionInfo.isBookmarked,
            "isCorrectAnswer": questionInfo.isCorrect,
            "isSkipped": questionInfo.isSkipped,
            "questionId": questionInfo.questionid,
            "questionType": questionInfo.questionType,
            "targetExamId": this.targetExamId,
            "timeTakenInSecs": questionInfo.timeSpentOnQuestion,
            "userAnswers": questionInfo.questionResponse == "null" ? null :  questionInfo.questionResponse,
            "isLiked" :    questionInfo.isLiked,
            "isDisLiked":  questionInfo.isDisLiked
       
        }

    ],

    "subjectId": this.selfLearnService.getSubjectId(),

    "pyqcomplete": true,

    // "totalPages": 1,

    // "totalRecords": 866
  }
    this.selfLearnService.submitPyqResponse(finalPayLoad).subscribe((res:any) => {
   
    })
  }
  getDefaultInfoForQuestions(){
    this.spinner.show();
    this.selfLearnService.getPyqAttemptedQuestions(this.targetExamId).subscribe((res:any) => {
      this.answeresQuestionData = res.data;
      this.questionsData.map((question:any,index:any) => {
        let tempQueData:any;
        if( this.answeresQuestionData.length >0){
           tempQueData = this.answeresQuestionData.find((item:any) => item.questionId == question.question_id)
        }
         if(tempQueData &&  this.answeresQuestionData.length >0 ){
          question.questionInfo = {
            "tenantId": this.userInfo.userDto.tenantId.toString(),
            "studentid": this.userId.toString() ,
            "phone": this.userInfo.phoneNumber,
            "admissionNumber": this.userInfo.userDto.admissionNumber,
            "questionid": tempQueData.questionId,
            "marks": 0,
            "questionResponse":localStorage.getItem('showAnseredQuestions')!='false' ? "null" : tempQueData.userAnswers,
            "questionStatus": "",
            "questionIndex": index.toString(),
            "startExamTimeStamp": moment().unix().toString(),
            "timeSpentOnQuestion": tempQueData.timeTakenInSecs,
            "isVisited":tempQueData.isAttempted,
            "isSubmitted": localStorage.getItem('showAnseredQuestions')!='false' ? false : tempQueData.isAttempted, 
            "questionType" : tempQueData.question_type,
            "isBookmarked" : tempQueData.isBookmarked,
            "isLiked" : tempQueData.isLiked,
            "isDisLiked" : tempQueData.isDisLiked,
            "likeCount" : tempQueData.likeCount

        }
            }else{
              question.questionInfo = {
                "tenantId": this.userInfo.userDto.tenantId.toString(),
                "studentid": this.userId.toString() ,
                "phone": this.userInfo.phoneNumber,
                "admissionNumber": this.userInfo.userDto.admissionNumber,
                "questionid": question.question_id,
                "marks": 0,
                "questionResponse": "null",
                "questionStatus": "notAnswered",
                "questionIndex": index.toString(),
                "questionResponseTimeStamp":"",
                "startExamTimeStamp": moment().unix().toString(),
                "timeSpentOnQuestion": 0,
                "isVisited":false,
                "isSubmitted":false,
                "questionType" : question.question_type,
                "isBookmarked" :false,
                "isLiked" :false,
                "isDisLiked" : false,
                "likeCount" : false
            }
            }
            this.spinner.hide();

      });
      // if(this.answeresQuestionData.length > 0){
      //   this.currentQuestionNumber = this.answeresQuestionData.length-1; 
      // }else{
      //   this.currentQuestionNumber =0;
      // }
     
      // this.currentQuestionData = this.questionsData[this.currentQuestionNumber];
       this.updateCurrentQuestionTimer()
    })
  }
  updateCurrentQuestionTimer(){
  let tempQuestionData:any =  this.questionsData[this.currentQuestionNumber];
  clearInterval(this.interval)
  this.timeSpent = tempQuestionData.questionInfo.timeSpentOnQuestion? tempQuestionData.questionInfo.timeSpentOnQuestion : 0;
  this.isCurrentQuestionSubmitted = tempQuestionData.questionResponse  == "null" ? 0 : tempQuestionData.questionResponse;
  this.startTimer();
  }
  fmtMSS(s:any){   
  return(s-(s%= 60))/60 +(9 < s ? ':':':0') + s ;      
  }


  redirectToVideoPage(){
    localStorage.removeItem("selfLearnSelectedPlayList");
    localStorage.removeItem("selfLearnPreviousPage", );
    localStorage.removeItem('selfLearnSelectedVideoId')
    localStorage.setItem('selectedTopicName',this.selfLearnService.getTopicName());
    localStorage.setItem('exerciseCurrentQuestion',this.currentQuestionNumber);
    localStorage.setItem('showAnseredQuestions','false');
    localStorage.setItem("selfLearnPreviousPage", 'selfLearn-V2/pyp-chapter-questions');
    localStorage.setItem('selfLearnSelectedVideoId',this.questionsData[this.currentQuestionNumber].video_solution_data.videoId)
    this.router.navigateByUrl('selfLearn-V2/videoplayback');
  }
  getVideoSolution() {

    if (this.questionsData[this.currentQuestionNumber].question.video_solution_id) {
 
      this.selfLearnService.getVideoCms(Number(this.questionsData[this.currentQuestionNumber].question.video_solution_id)).subscribe((resp: any) => {
        if(resp?.video){
          resp.video.videoUrl =  resp.video.videoURL;
          resp.video.videoName = resp?.video?.title
        }
        this.questionsData[this.currentQuestionNumber].video_solution_data = { ...resp?.video }
        this.questionsData[this.currentQuestionNumber].duration = this.timeConvert(resp?.video?.duration||0)      
      })
    }
  }

   // Question type multiple answer type
   onMultiAnswerSelect(index:any, event:any){
    console.log(index,'index')
    console.log(event.target.value,'event');
   this.selectedMultiAnswer[index+1] = true;
    this.flagData.isQuestionSubmit = true
   this.flagData.isSelected = true;
   this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse = (index+1).toString();
   console.log(this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse);
  
    }
   onMultiAnswerDeSelect(index:any, event:any){
    this.selectedMultiAnswer[index+1] = false;
  //   this.selectedData.selectedQuestionData.pop(''+(index+1))
  //  this.selectedData.selectedQuestionChoiceData.pop(''+(index+1))
      console.log( this.selectedMultiAnswer);
   }
  checkMultiSelectAnswer(index:any){ 
     let correctans  = this.questionsData[this.currentQuestionNumber].question.correct_answer.toString();
    let mres = this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse.split(",");
     if(mres?.includes(String(index+1))){
        if(correctans.includes(String(index+1))){
         return 'correctAns';
      }else{
          return 'wrongAns';
        }  
      }else{
       if(correctans.includes(String(index+1))){
        return 'correctAns';
     }else{
         return '';
       }
    }
  }
   checkMultiChecked(index:any){ 
    let mres = this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse.toString();
     //mres = mres?.map((arr:any) => arr.trim());
     if(mres?.includes(String(index+1))){ 
          return true;
      }else{
         return false;
       }  
   }
   
    checkAnswer(){
      if(this.selectedData.selectedQuestionData[0]!=this.revCardData.question.correct_answer[0]){
        return false
      }else {
        return true;
      }
    }
     // Question type numeric
  padBtnClick(e: any, btnVal: any) {
    e.preventDefault();
    e.stopPropagation();
  
    let newAns: any;
    const currentAns:any = this.selectedAnswer || "";
    this.selectedNPadBtnText = btnVal;
    if (btnVal == "clear") {
      this.selectedNPadBtnText = "";
      this.flagData.isSelected = false;
      this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse ='null'
    }else if(btnVal == "-"){
      if(this.selectedAnswer[0]==null){
        newAns = btnVal;
        this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse = newAns;
      }else{
        newAns = this.selectedAnswer[0];
        this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse = newAns
      }
    } else {
      this.flagData.isSelected = true
      newAns = this.selectedAnswer[0] ? this.selectedAnswer[0]+btnVal : btnVal;
      this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse = newAns
    }
    this.selectedAnswer = [newAns]
    console.log(  this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse)
    this.flagData.isQuestionSubmit = true
      this.selectedData.selectedQuestionData =this.selectedAnswer
      this.selectedData.selectedQuestionChoiceData = this.selectedAnswer
  }
  isAnswerChecked(response:any,index:any){
   if(Number(response) ==  Number(index)){
    return true;
   }else{
    return false
   }
  }

  bookMarkQuestion(){
    this.questionsData[this.currentQuestionNumber].questionInfo.isBookmarked = !this.questionsData[this.currentQuestionNumber].questionInfo.isBookmarked;
    this.saveQuestionResponse(this.questionsData[this.currentQuestionNumber].questionInfo);
  }
  openUserFeedbackDialog() {
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {

      data: {assetType:"questionReport",
      assetId:  this.questionsData[this.currentQuestionNumber].question_id}
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  userLike(){
    this.questionsData[this.currentQuestionNumber].questionInfo.isLiked = !this.questionsData[this.currentQuestionNumber].questionInfo.isLiked;
    this.questionsData[this.currentQuestionNumber].questionInfo.isDisLiked = false;
    this.saveQuestionResponse(this.questionsData[this.currentQuestionNumber].questionInfo);
  }

  userDislike(){
    this.questionsData[this.currentQuestionNumber].questionInfo.isDisLiked = !this.questionsData[this.currentQuestionNumber].questionInfo.isDisLiked;
    this.questionsData[this.currentQuestionNumber].questionInfo.isLiked = false;
    this.saveQuestionResponse(this.questionsData[this.currentQuestionNumber].questionInfo);
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {
      data: {assetType:"questionFeedback",
      assetId:  this.questionsData[this.currentQuestionNumber].question_id}
    });
    
    dialogRef.afterClosed().subscribe(() => {
    });
  }

}
